export default __webpack_public_path__ + "static/media/adobe-illustrator.11f5b57b.svg";